import type { UnionToTuple } from "type-fest";
import { z } from "zod";

import { zOutSchema2 } from "./common";

import type { OrderServicePorts } from "~/entities/order/model";
import { Request, Response } from "~/shared/api";

const zRes = Response.Schema.zSuccessful(200, Request.Pagination.Page.zSchema(zOutSchema2));
type Res = z.infer<typeof zRes>;

const zFieldsToSortBy = z.enum(
  Object.values(zRes.shape.body.shape.data.shape.items.element.keyof().Enum) as UnionToTuple<
    keyof Res["body"]["data"]["items"][number]
  >,
);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const MAP_OF_FIELDS_TO_SORT_BY: Record<
  OrderServicePorts.ProviderIos.GetPaginated.FieldsToSortBy,
  FieldsToSortBy
> = {
  id: "id",
  number: "orderNumber",
  status: "status",
  "payment.isCompleted": "isPaid",
  cost: "totalPrice",
  createdAt: "createdDate",
  moveIsScheduledFor: "orderDateTime",
  contactPersonFullName: "contactName",
  from: "fromAddress",
  to: "toAddress",
};

export { FieldsToSortBy, MAP_OF_FIELDS_TO_SORT_BY, zFieldsToSortBy, zRes };
export type { Res };
